"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowMeter = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const typeName = 'FlowMeter';
class FlowMeter extends datamodel_core_1.DeviceEnabledType {
    constructor(ob) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        super(ob.type || typeName, ob);
        this.purposeType = (_a = ob.purposeType) !== null && _a !== void 0 ? _a : '';
        this.maximumFlowRate = (_c = (_b = ob.maximumFlowRate) !== null && _b !== void 0 ? _b : ob.maxrate) !== null && _c !== void 0 ? _c : null;
        this.flow = (_d = ob.flow) !== null && _d !== void 0 ? _d : null;
        this.location = (_e = ob.location) !== null && _e !== void 0 ? _e : ob.position;
        this.pulseFlowAmount = (_f = ob.pulseFlowAmount) !== null && _f !== void 0 ? _f : 1;
        this.flowPerPulse = (_h = (_g = ob.flowPerPulse) !== null && _g !== void 0 ? _g : ob.flowperpulse) !== null && _h !== void 0 ? _h : null;
        this.lifetimeCount = (_j = ob.lifetimeCount) !== null && _j !== void 0 ? _j : null;
        this.periodicCount = (_k = ob.periodicCount) !== null && _k !== void 0 ? _k : null;
        this.periodFlow = (_l = ob.periodFlow) !== null && _l !== void 0 ? _l : 0;
        this.flowToday = (_m = ob.flowToday) !== null && _m !== void 0 ? _m : null;
        this.flowYesterday = (_o = ob.flowYesterday) !== null && _o !== void 0 ? _o : null;
        this.periodLength = (_p = ob.periodLength) !== null && _p !== void 0 ? _p : null;
        this.flowRate = (_q = ob.flowRate) !== null && _q !== void 0 ? _q : null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of Water Flow Meter',
            },
            purposeType: {
                type: 'String',
                editable: true,
                label: 'Purpose/ Type',
                name: 'purpose/Type',
                description: 'Purpose/ type of Flow',
            },
            meterType: {
                type: 'String',
                editable: true,
                label: 'Meter Type',
                name: 'meterType',
                description: 'Meter type',
            },
            diameter: {
                type: 'Number',
                editable: true,
                label: 'Diameter',
                name: 'diameter',
                description: 'Diameter of Water Flow pipe - mm',
            },
            maximumFlowRate: {
                type: 'Number',
                editable: true,
                label: 'Maximum Flow Rate (L/m)',
                name: 'maximumFlowRate',
                description: 'Maximum flow rate ',
            },
            // setFlowRate: {
            //   type: "Number",
            //   editable: true,
            //   label: "Set Flow Rate",
            //   name: "setFlowRate",
            //   description: "Flow rate set for the Water Flow",
            // },
            // flow: {
            //   type: "Number",
            //   editable: true,
            //   label: "Flow",
            //   name: "flow",
            //   description: "Water flow  litres/ sec and cubic metres/ sec",
            // },
            location: {
                type: 'object',
                editable: true,
                label: 'Location',
                name: 'location',
                description: 'Location of  Water Flow Meter (lat/ long)',
            },
            // pulseCounterFrequency: {
            //   type: "Number",
            //   editable: true,
            //   label: "Pulse counter frequency",
            //   name: "pulseCounterFrequency",
            //   description: "Frequency of pulse counts from meter to measure flow",
            // },
            pulseFlowAmount: {
                type: 'Number',
                editable: true,
                label: 'Flow (Liters) per pulse',
                name: 'pulseFlowAmount',
                description: 'Flow per pulse to calculate water flow',
            },
            comments: {
                type: 'String',
                editable: true,
                label: 'Comments',
                name: 'comments',
                description: 'Free text for info ',
            },
        };
    }
}
exports.FlowMeter = FlowMeter;
